import styled, { css } from 'styled-components';
import Flag from 'components/Flag';
import { FaCheck } from 'react-icons/fa';
import Tooltip from 'components/Tooltip';
import { fadeIn } from 'style';
import { variants, th } from 'style/theme';

export const Wrapper = styled.div`
  ${variants('size', {
    medium: css`
      margin-bottom: 22px;
    `,
    large: css`
      margin-bottom: 30px;
    `,
    extralarge: css`
      margin-bottom: 40px;
    `
  })}

  display: flex;
  position: relative;
  justify-content: space-between;
`;

export const Plus = styled.span`
  ${variants('variant', {
    light: css`
      color: ${th('colors.white')};
    `,
    dark: css`
      color: ${th('colors.black')};
    `
  })}
`;

export const InputContainer = styled.div`
  width: ${(props) => (props.isFlagVisible ? 'calc(100% - 25px)' : '100%')};
  margin-left: ${(props) => (props.isFlagVisible ? '25px' : '0')};
  transition: 0.3s;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > input {
    padding-left: 2.5px;
    padding-right: 2.5px;

    :first-of-type {
      width: 45px;
      margin-right: 14px;
      margin-left: 6px;
    }

    ${({ disabled }) =>
      disabled &&
      css`
        opacity: 0.7;
        border-bottom: none;

        :first-of-type {
          margin-right: 0;
        }
      `}
  }
`;

export const CountryFlag = styled(Flag)`
  display: ${(props) => (props.isFlagVisible ? 'block' : 'none')};
  position: absolute;
  width: 18px;
  margin-right: 4px;
  top: 11px;
  animation: ${fadeIn} 0.4s;
  animation-delay: 0.15s;
  animation-fill-mode: both;
`;

export const Optional = styled.span`
  font-weight: 400;
  font-size: 14px;
  margin-left: 4px;
`;

export const Error = styled.span`
  margin-left: 5px;
  color: ${th('colors.red')};
  font-weight: 700;
  font-size: 14px;
`;

export const CheckIcon = styled(FaCheck)`
  margin-left: 7px;
  font-size: 14px;
  color: ${th('colors.bermudaGreen')};
`;

export const StyledTooltip = styled(Tooltip)`
  margin-left: 8px;
`;
